__turbopack_context__.v({
  "award": "zQ6oPW_award",
  "awardDescription": "zQ6oPW_awardDescription",
  "awardImage": "zQ6oPW_awardImage",
  "awardImageWrapper": "zQ6oPW_awardImageWrapper",
  "awardLink": "zQ6oPW_awardLink",
  "awardSubtitle": "zQ6oPW_awardSubtitle",
});
